import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import PageTracker from '../../../common/PageTrackerHelper';


export default {
  name: 'login',
  components: {VueElementLoading},
  props: [],
  mixins:[PageTracker],
  data() {
    return {
      username: '',
      password: '',
      tokenId: '',
      isLoading: false,
    }
  },
  computed: {

  },
  mounted() {
    //console.log('apiUrl.api_url',apiUrl.api_url);
    localStorage.removeItem('lmaccesspermissiondata')
    localStorage.removeItem('lmaccessuserdata')
    localStorage.removeItem('isLoggedIn')
    localStorage.removeItem('IsRVPPaperless')
    localStorage.removeItem('isLoginAuthCheck')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('IsLocusRouting')
    localStorage.removeItem('isDayendclosurefeature')
    localStorage.removeItem('lmUserToken')
    localStorage.removeItem('userUniqueKey');
    localStorage.removeItem('lmUserTokenId');
    localStorage.removeItem('allhubaccesslist');
    localStorage.removeItem('hubaccesslist')
    if(this.$route.params.id==undefined){

    }else{
      this.tokenId = this.$route.params.id;
      this.ssologin();
    }
  },
  methods: {

    ssologin(){
      axios.post(apiUrl.api_url + 'user/ssoauth', {
          'token': this.tokenId
        })
        .then(async(response) => {

            if(response.data.code==200){
              let userKey = await this.generateEncryptDecryptKey();
              window.localStorage.setItem('userUniqueKey',userKey);
              let permissionEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data.data.access), userKey);
              let usersEncrupt = CryptoJS.AES.encrypt(JSON.stringify(response.data.data), userKey);
              window.localStorage.setItem('lmaccesspermissiondata', permissionEncrypt);
              window.localStorage.setItem('lmaccessuserdata', usersEncrupt);
              window.localStorage.setItem('isLoggedIn',true);
              window.localStorage.setItem('isLoginAuthCheck',response.data.isLoginAuthCheck);
              window.localStorage.setItem('lmUserToken',this.tokenId);
              if(response.data.isLoginAuthCheck &&  response.data.refreshToken.trim() != '') {
                window.localStorage.setItem('refreshToken',response.data.refreshToken);
              }

              permissionEncrypt = window.localStorage.getItem('lmaccesspermissiondata');
              let permissiondatabytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), userKey);
              let permissiondataplaintext = permissiondatabytes.toString(CryptoJS.enc.Utf8);

              let permissiondata = JSON.parse(permissiondataplaintext);

              this.$router.push(permissiondata[0].url);
              this.$alertify.success('Successfully logged In.!');
            }else{

              //console.log('response.',response);
              if(response.data.code == 302) {
                window.location.href= response.data.redirecturl;
              } else {
                //console.log('response.',response);
               this.$alertify.error(response.data.error);
              }
            }
          })
        .catch((httpException) => {
          this.$router.push('/login');
          this.$alertify.error("Logging Failed");
          console.error('exception is:::::::::', httpException)
        })
    },

    checklogin() {
      //let projectID = CryptoJS.AES.encrypt('$LAST$Mile%#$', "xb-cod-security");
      //let projectInfo = projectID.toString(CryptoJS.enc.Utf8);
      //console.log(apiUrl.api_url);
      this.isLoading = true;
      axios.post(apiUrl.api_url + 'user/userauth', {
          'username': this.username,
          'password': this.password
        })
        .then(async(response) => {
            if(response.data.code==200){
              let userKey = await this.generateEncryptDecryptKey();
              window.localStorage.setItem('userUniqueKey',userKey);
              let permissionEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data.data.access), userKey);
              let usersEncrupt = CryptoJS.AES.encrypt(JSON.stringify(response.data.data), userKey);
              window.localStorage.setItem('lmaccesspermissiondata', permissionEncrypt);
              window.localStorage.setItem('lmaccessuserdata', usersEncrupt);
              window.localStorage.setItem('isLoggedIn',true);
              window.localStorage.setItem('lmUserToken',response.data.lmUserToken)
              // response.data.isLoginAuthCheck = true; //****** REMOVE THIS LINE ******///.
              window.localStorage.setItem('isLoginAuthCheck',response.data.isLoginAuthCheck);
              if(response.data.isLoginAuthCheck &&  response.data.refreshToken.trim() != '') {
                window.localStorage.setItem('refreshToken',response.data.refreshToken);
              }

              permissionEncrypt = window.localStorage.getItem('lmaccesspermissiondata');
              let permissiondatabytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), userKey);
              let permissiondataplaintext = permissiondatabytes.toString(CryptoJS.enc.Utf8);

              let permissiondata = JSON.parse(permissiondataplaintext);
              this.$router.push(permissiondata[0].url);
              this.$alertify.success('Successfully logged in.!');
            } else {
              //console.log('response.',response);
              if(response.data.code == 302) {
                window.location.href= response.data.redirecturl;
              } else {
                //console.log('response.',response);
               this.$alertify.error(response.data.error);
              }
            }
            this.isLoading = false;
            //let hubEncrypt = CryptoJS.AES.encrypt(JSON.stringify(response.data.hubData), "Key");
            //window.localStorage.setItem('accesshubdata', hubEncrypt);
          })
        .catch((httpException) => {
          this.isLoading = false;
          this.$alertify.error("Logging Failed");
          console.error('exception is:::::::::', httpException)
        })
    },

    resetpassword(){
      window.location.href = apiUrl.umurl+'/#/resetpasswordwith2fa?redirecturl='+window.location.href;
    },

  }
}



// WEBPACK FOOTER //
// ./src/views/components/login/login.component.js